// extracted by mini-css-extract-plugin
module.exports = {"loading_spoon":"Loading-module__loading_spoon___2w-O4"};